import { createSelector } from '@ngrx/store'
import {
  CreateEditTransAction,
  TransactionCreatePermissions,
  TransactionsRedux,
} from '.'
import { RootState } from '../../root.model'

const transactionsState = (state: RootState) => state.panels.transactions

/**
 * Gets the clearwater transaction data that is selected
 */
export const selectTransactions = createSelector(
  transactionsState,
  (state: TransactionsRedux) => state.transactions,
)

export const getSelectAllRowsEnabled = createSelector(
  transactionsState,
  (state: TransactionsRedux) => state.selectAllRowsEnabled,
)

export const selectCommandsMetrics = createSelector(
  transactionsState,
  (state: TransactionsRedux) => state.commandsMetrics,
)

export const getSelectAllExtTxsRowsEnabled = createSelector(
  transactionsState,
  (state: TransactionsRedux) => state.selectAllExtTxsRowsEnabled,
)

export const selectCreateEditTransActions = createSelector(
  transactionsState,
  (state: TransactionsRedux) => state.createEditTransActions,
)

const createEditTransActionValues: string[] = Object.values(
  CreateEditTransAction,
)

export const selectAnyCreatePermission = createSelector(
  selectCreateEditTransActions,
  actions => {
    return (
      actions == null ||
      actions.some(a => createEditTransActionValues.includes(a))
    )
  },
)

export const selectTransactionCreatePermissions = createSelector(
  selectCreateEditTransActions,
  (actions): TransactionCreatePermissions => {
    if (actions == null) {
      return {
        createTrade: true,
        createCashEntry: true,
        createFxSpotTrade: true,
        createCurrencyForward: true,
        createWireTransfer: true,
        createDirectTransfer: true,
        createSecurityTransfer: true,
      }
    }

    return {
      createTrade: actions.includes(CreateEditTransAction.CreateTrade),
      createCashEntry: actions.includes(CreateEditTransAction.CreateCashEntry),
      createFxSpotTrade: actions.includes(
        CreateEditTransAction.CreateFxSpotTrade,
      ),
      createCurrencyForward: actions.includes(
        CreateEditTransAction.CreateCurrencyForward,
      ),
      createWireTransfer: actions.includes(
        CreateEditTransAction.CreateWireTransfer,
      ),
      createDirectTransfer: actions.includes(
        CreateEditTransAction.CreateDirectTransfer,
      ),
      createSecurityTransfer: actions.includes(
        CreateEditTransAction.CreateSecurityTransfer,
      ),
    }
  },
)
